export default {
  "hospitals": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hastaneler"])},
  "projects": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Projeler"])},
  "devices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cihazlar"])},
  "assets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Malzemeler"])},
  "tests": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Testler"])},
  "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hakkinda"])}
}